(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2265],{

/***/ 82624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexView; }
/* harmony export */ });
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(78402);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function IndexView(props) {
  var pageKey = props.pageKey,
      _props$menu = props.menu,
      menu = _props$menu === void 0 ? [] : _props$menu,
      title = props.title,
      bgImage = props.bgImage,
      _props$bgImageMobile = props.bgImageMobile,
      bgImageMobile = _props$bgImageMobile === void 0 ? bgImage : _props$bgImageMobile,
      className = props.className;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("section", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), className),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-pc"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImage, ")")
        },
        children: title
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default()["for-mobile"]),
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("header", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().header),
        style: {
          backgroundImage: "url(".concat(bgImageMobile, ")")
        },
        children: title
      })
    }), menu.length > 0 && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("nav", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().nav),
      children: menu.map(function (item) {
        var key = item.key,
            text = item.text,
            _item$target = item.target,
            target = _item$target === void 0 ? '_self' : _item$target;
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("a", {
          className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().navItem), pageKey === item.key && (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active)),
          target: target,
          rel: "noreferrer",
          href: item.link,
          children: text
        }, key);
      })
    })]
  });
}

/***/ }),

/***/ 91519:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(89128);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);



function Home(props) {
  var className = props.className,
      styles = props.styles,
      _props$alt = props.alt,
      alt = _props$alt === void 0 ? 'img' : _props$alt,
      src = props.src,
      _props$fitMode = props.fitMode,
      fitMode = _props$fitMode === void 0 ? 'fill-width' : _props$fitMode,
      click = props.click;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().container), !!className && className),
    style: styles !== null && styles !== void 0 ? styles : {},
    onClick: click,
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("img", {
      className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().img), (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default())[fitMode]),
      alt: alt,
      src: src
    })
  });
}

/***/ }),

/***/ 39609:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _style_index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(29448);
/* harmony import */ var _style_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_style_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
// loading





var Loading = function Loading(props) {
  var _props$visible = props.visible,
      visible = _props$visible === void 0 ? true : _props$visible,
      children = props.children,
      style = props.style;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: (_style_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().loading),
    style: style,
    children: visible ? /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 32 32",
        width: "32",
        height: "32",
        fill: "#44b5ff",
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          opacity: ".25",
          d: "M16 0 A16 16 0 0 0 16 32 A16 16 0 0 0 16 0 M16 4 A12 12 0 0 1 16 28 A12 12 0 0 1 16 4"
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("path", {
          d: "M16 0 A16 16 0 0 1 32 16 L28 16 A12 12 0 0 0 16 4z",
          children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("animateTransform", {
            attributeName: "transform",
            type: "rotate",
            from: "0 16 16",
            to: "360 16 16",
            dur: "0.8s",
            repeatCount: "indefinite"
          })
        })]
      })
    }) : children
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (Loading);

/***/ }),

/***/ 14197:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(65058);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var components_image_cdnImage__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91519);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(40238);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(85893);








var Home = function Home(props, ref) {
  var className = props.className,
      propsStyle = props.propsStyle,
      hotWords = props.hotWords,
      _props$placeholder = props.placeholder,
      placeholder = _props$placeholder === void 0 ? '请输入你的问题' : _props$placeholder,
      onStartSearch = props.onStartSearch;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_3__.useState)(''),
      val = _useState[0],
      setVal = _useState[1];

  (0,react__WEBPACK_IMPORTED_MODULE_3__.useImperativeHandle)(ref, function () {
    return {
      setValue: function setValue(val) {
        setVal(val);
      }
    };
  });

  var onChange = function onChange(e) {
    setVal(e.target.value);
  };

  var onClear = function onClear() {
    setVal('');
    onStartSearch('');
  };

  var onPress = function onPress(event) {
    if (event.keyCode === 13) {
      onStartSearch(val);
    }
  };

  var onSearchHotWord = function onSearchHotWord(word) {
    setVal(word);
    onStartSearch(word);
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().search), !!className && className),
    style: propsStyle !== null && propsStyle !== void 0 ? propsStyle : {},
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchContent),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("input", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchInput),
        value: val,
        type: "text",
        maxLength: 30,
        placeholder: placeholder,
        autoComplete: "off",
        onChange: onChange,
        onKeyUp: onPress
      }), val && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_image_cdnImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
        click: onClear,
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().clearImg),
        src: "".concat(constants_index__WEBPACK_IMPORTED_MODULE_2__/* .cdnImgPath */ .Jp, "/support/faq/pc/clear-icon.png")
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("button", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchBtn),
        onClick: function onClick() {
          return onStartSearch(val);
        },
        children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)(components_image_cdnImage__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().searchIcon),
          src: "".concat(constants_index__WEBPACK_IMPORTED_MODULE_2__/* .cdnImgPath */ .Jp, "/support/faq/pc/search-icon.png")
        })
      })]
    }), hotWords && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsxs)("div", {
      className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hot),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["for-pc"]),
        children: "\u70ED\u95E8\u641C\u7D22\u8BCD\uFF1A"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("p", {
        className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default()["for-mobile"]),
        children: "\u70ED\u95E8\u641C\u7D22\u8BCD"
      }), hotWords.map(function (word) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_4__.jsx)("span", {
          className: (_index_module_scss__WEBPACK_IMPORTED_MODULE_5___default().hotWord),
          onClick: function onClick() {
            return onSearchHotWord(word);
          },
          children: word
        }, word);
      })]
    })]
  });
};

/* harmony default export */ __webpack_exports__["Z"] = (/*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_3__.forwardRef)(Home));

/***/ }),

/***/ 80318:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexView; }
/* harmony export */ });
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(75928);
/* harmony import */ var _index_module_scss__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_index_module_scss__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




function IndexView(props) {
  var productList = props.productList,
      activeId = props.activeId,
      onClickTab = props.onClickTab,
      classNames = props.classNames;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_0___default()((_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().leftTabWrapper), !!classNames && classNames),
    children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("ul", {
      children: productList.map(function (item) {
        return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)("li", {
          className: activeId === item.id ? (_index_module_scss__WEBPACK_IMPORTED_MODULE_2___default().active) : '',
          onClick: function onClick() {
            return onClickTab(item.id);
          },
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: 'for-pc',
            children: item.productName
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
            className: 'for-mobile',
            children: '' + item.productName.substr(0, 7)
          })]
        }, item.id);
      })
    })
  });
}

/***/ }),

/***/ 4119:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ IndexView; }
/* harmony export */ });
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40238);
/* harmony import */ var components_banner__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(82624);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(85893);



function IndexView(props) {
  var pageKey = props.pageKey;
  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_2__.jsx)(components_banner__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
    pageKey: pageKey,
    bgImage: constants_index__WEBPACK_IMPORTED_MODULE_0__/* .supportBanner */ .vh,
    bgImageMobile: constants_index__WEBPACK_IMPORTED_MODULE_0__/* .supportBannerMobile */ .Oy,
    menu: constants_index__WEBPACK_IMPORTED_MODULE_0__/* .supportNav */ .i5,
    title: "\u652F\u6301\u4E2D\u5FC3"
  });
}

/***/ }),

/***/ 79319:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "__N_SSP": function() { return /* binding */ __N_SSP; },
/* harmony export */   "default": function() { return /* binding */ Home; }
/* harmony export */ });
/* harmony import */ var antd_lib_list_style__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(69870);
/* harmony import */ var antd_lib_list_style__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(antd_lib_list_style__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var antd_lib_list__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(9922);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(27812);
/* harmony import */ var antd_lib_pagination_style__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(45822);
/* harmony import */ var antd_lib_pagination_style__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(antd_lib_pagination_style__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var antd_lib_pagination__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(16661);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(59499);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(50029);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(87794);
/* harmony import */ var _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var components_layout__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(16569);
/* harmony import */ var components_support_header__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(4119);
/* harmony import */ var components_button__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(89231);
/* harmony import */ var styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(63973);
/* harmony import */ var styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default = /*#__PURE__*/__webpack_require__.n(styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17__);
/* harmony import */ var components_search__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(14197);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(67294);
/* harmony import */ var components_loading__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(39609);
/* harmony import */ var components_sideTabs__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(80318);
/* harmony import */ var constants_index__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(40238);
/* harmony import */ var action_index__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(37121);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(94184);
/* harmony import */ var classnames__WEBPACK_IMPORTED_MODULE_15___default = /*#__PURE__*/__webpack_require__.n(classnames__WEBPACK_IMPORTED_MODULE_15__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(85893);








function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_defineProperty__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }








 // import useSWR, { SWRConfig } from 'swr';










var __N_SSP = true;
function Home(props) {
  var productList = props.productList,
      list = props.list,
      current = props.current,
      total = props.total,
      hotWords = props.hotWords,
      categoryId = props.categoryId;
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  if (router.isFallback) {
    return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(components_loading__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {});
  }

  var onStartSearch = function onStartSearch(val) {
    if (val) {
      router.push("/support/faq/search?query=".concat(val));
    }
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)(components_layout__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)((next_head__WEBPACK_IMPORTED_MODULE_4___default()), {
      children: /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("title", {
        children: "\u5E38\u89C1\u95EE\u9898 - \u5C0F\u9C7C\u6613\u8FDE-\u5B98\u7F51-\u8BA9\u4E16\u754C\u96F6\u8DDD\u79BB"
      })
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("section", {
      className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().container),
      children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(components_support_header__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {
        pageKey: "faq"
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(components_search__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, {
        className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().searchWrapper),
        hotWords: hotWords,
        onStartSearch: onStartSearch
      }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
        className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().body),
        children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(components_sideTabs__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
          classNames: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().sideTabs),
          productList: productList,
          activeId: categoryId,
          onClickTab: function onClickTab(activeId) {
            return router.replace("/support/faq/".concat(activeId), undefined, {
              scroll: false
            });
          }
        }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
          className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().rightMain),
          children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(MobileList, {
            categoryId: categoryId,
            list: list,
            total: total,
            current: current
          }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(PcList, {
            categoryId: categoryId,
            list: list,
            total: total,
            current: current
          })]
        })]
      })]
    })]
  }, categoryId);
}

var Item = function Item(item) {
  var router = (0,next_router__WEBPACK_IMPORTED_MODULE_5__.useRouter)();

  var onViewInfo = function onViewInfo() {
    router.push("/support/faq/detail/".concat(item.id));
  };

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
    className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().faqItem),
    onClick: onViewInfo,
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
      className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().title),
      children: item.title
    }), /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
      className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().icon)
    })]
  }, item.id);
};

var PcList = function PcList(props) {
  var categoryId = props.categoryId,
      list = props.list,
      current = props.current,
      faqTotal = props.total;

  var _useState = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(list),
      faqList = _useState[0],
      setFaqList = _useState[1];

  var _useState2 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(faqTotal),
      total = _useState2[0],
      setTotal = _useState2[1];

  var onChangePage = /*#__PURE__*/function () {
    var _ref = (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee(page) {
      var res, _total, records;

      return _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return action_index__WEBPACK_IMPORTED_MODULE_14__/* .action.getFaqList */ .a.getFaqList(categoryId, page, constants_index__WEBPACK_IMPORTED_MODULE_13__/* .pageSize */ .sk);

            case 2:
              res = _context.sent;

              if (res) {
                _total = res.total, records = res.records;
                setFaqList(records);
                setTotal(_total);
              }

            case 4:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));

    return function onChangePage(_x) {
      return _ref.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsxs)("div", {
    className: classnames__WEBPACK_IMPORTED_MODULE_15___default()((styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().pcWrapper), (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default()["for-pc"])),
    children: [/*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)("div", {
      className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().faqList),
      children: faqList.map(function (item) {
        return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_10__.createElement)(Item, _objectSpread(_objectSpread({}, item), {}, {
          key: item.id
        }));
      })
    }), total > constants_index__WEBPACK_IMPORTED_MODULE_13__/* .pageSize */ .sk && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(antd_lib_pagination__WEBPACK_IMPORTED_MODULE_19__["default"], {
      showLessItems: true,
      className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().pagination),
      total: total,
      defaultCurrent: current,
      showSizeChanger: false,
      pageSize: constants_index__WEBPACK_IMPORTED_MODULE_13__/* .pageSize */ .sk,
      onChange: onChangePage
    })]
  });
};

var MobileList = function MobileList(props) {
  var categoryId = props.categoryId,
      list = props.list,
      current = props.current,
      faqTotal = props.total;

  var _useState3 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(list),
      faqList = _useState3[0],
      setFaqList = _useState3[1];

  var _useState4 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(faqTotal),
      total = _useState4[0],
      setTotal = _useState4[1]; // 移动端


  var _useState5 = (0,react__WEBPACK_IMPORTED_MODULE_10__.useState)(false),
      loading = _useState5[0],
      setLoading = _useState5[1];

  var page = (0,react__WEBPACK_IMPORTED_MODULE_10__.useRef)(current);

  var onLoadMore = /*#__PURE__*/function () {
    var _ref2 = (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_asyncToGenerator__WEBPACK_IMPORTED_MODULE_18__/* ["default"] */ .Z)( /*#__PURE__*/_workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().mark(function _callee2() {
      var res, _total2, records;

      return _workspace_repo_node_modules_next_dist_compiled_babel_runtime_regenerator__WEBPACK_IMPORTED_MODULE_3___default().wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              setLoading(true);
              page.current += 1;
              _context2.next = 4;
              return action_index__WEBPACK_IMPORTED_MODULE_14__/* .action.getFaqList */ .a.getFaqList(categoryId, page.current, constants_index__WEBPACK_IMPORTED_MODULE_13__/* .pageSize */ .sk);

            case 4:
              res = _context2.sent;

              if (res) {
                _total2 = res.total, records = res.records;
                setTotal(_total2);
                setFaqList(function (list) {
                  return [].concat((0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(list), (0,_workspace_repo_node_modules_next_dist_compiled_babel_runtime_helpers_esm_toConsumableArray__WEBPACK_IMPORTED_MODULE_20__/* ["default"] */ .Z)(records));
                });
              }

              setLoading(false);

            case 7:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2);
    }));

    return function onLoadMore() {
      return _ref2.apply(this, arguments);
    };
  }();

  return /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(antd_lib_list__WEBPACK_IMPORTED_MODULE_21__["default"], {
    className: classnames__WEBPACK_IMPORTED_MODULE_15___default()((styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().faqList), (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default()["for-mobile"])) // loading={initLoading}
    ,
    itemLayout: "horizontal",
    loadMore: total > faqList.length && /*#__PURE__*/(0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_16__.jsx)(components_button__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z, {
      category: "viewMore",
      className: (styles_support_faq_module_scss__WEBPACK_IMPORTED_MODULE_17___default().loadMore),
      onClick: onLoadMore,
      loading: loading,
      children: "\u67E5\u770B\u66F4\u591A"
    }),
    dataSource: faqList,
    renderItem: function renderItem(item) {
      return /*#__PURE__*/(0,react__WEBPACK_IMPORTED_MODULE_10__.createElement)(Item, _objectSpread(_objectSpread({}, item), {}, {
        key: item.id
      }));
    }
  });
};

/***/ }),

/***/ 26250:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/support/faq/[id]",
      function () {
        return __webpack_require__(79319);
      }
    ]);
    if(false) {}
  

/***/ }),

/***/ 78402:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"banner_container__oBe7a","nav":"banner_nav__R4D9K","navItem":"banner_navItem__z8je4","header":"banner_header__8mEeU","border__px":"banner_border__px__Rkq8K","border__px-before":"banner_border__px-before__jqV1R","border__px-before1":"banner_border__px-before1__rZGud","border-children1":"banner_border-children1__cwgjz","border-children2":"banner_border-children2__7N7DQ","for-mobile":"banner_for-mobile__9iMXJ","for-pc":"banner_for-pc__zlWnK","active":"banner_active___c3ly"};

/***/ }),

/***/ 89128:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"container":"cdnImage_container__YAbPG","fill-height":"cdnImage_fill-height__hIziF"};

/***/ }),

/***/ 29448:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"loading":"style_loading__4oDXS","loading-content":"style_loading-content__VXWzP"};

/***/ }),

/***/ 65058:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"search":"search_search__gj6rt","border__px":"search_border__px__cnDy_","border__px-before":"search_border__px-before__O_11W","border__px-before1":"search_border__px-before1__kbkZk","border-children1":"search_border-children1__jpXps","border-children2":"search_border-children2__ZdnsT","for-mobile":"search_for-mobile__BPhUR","for-pc":"search_for-pc___L_pR","searchContent":"search_searchContent__3pqWX","searchInput":"search_searchInput__d4OGA","clearImg":"search_clearImg__opSn0","searchBtn":"search_searchBtn__7CMzA","searchIcon":"search_searchIcon__mDxVo","hot":"search_hot__yhTrP","hotWord":"search_hotWord__LtcAW","noResult":"search_noResult__SMByG","noResultIcon":"search_noResultIcon__QordI"};

/***/ }),

/***/ 75928:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"border__px":"sideTabs_border__px__I8_DX","border__px-before":"sideTabs_border__px-before__U7H5D","border__px-before1":"sideTabs_border__px-before1__yNCjK","border-children1":"sideTabs_border-children1__1gVkS","border-children2":"sideTabs_border-children2__MUzR7","for-mobile":"sideTabs_for-mobile__WargK","for-pc":"sideTabs_for-pc__CEKrI","leftTabWrapper":"sideTabs_leftTabWrapper__Aqktf","active":"sideTabs_active__ExGsC"};

/***/ }),

/***/ 63973:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"body":"faq_body__s2eKj","border__px":"faq_border__px__3VQzF","border__px-before":"faq_border__px-before__chLxD","border__px-before1":"faq_border__px-before1__E3fBB","border-children1":"faq_border-children1__qdDjH","border-children2":"faq_border-children2__r6nE0","for-mobile":"faq_for-mobile__X661O","for-pc":"faq_for-pc__iSziF","rightMain":"faq_rightMain__rZ1Nx","faqList":"faq_faqList__nRrDw","faqItem":"faq_faqItem__HXepD","icon":"faq_icon__EfqHW","title":"faq_title__ylgXT","pagination":"faq_pagination__WoChg","searchWrapper":"faq_searchWrapper__DYjqd","sideTabs":"faq_sideTabs__vGfh8","loadMore":"faq_loadMore__C1cUG"};

/***/ })

},
/******/ function(__webpack_require__) { // webpackRuntimeModules
/******/ var __webpack_exec__ = function(moduleId) { return __webpack_require__(__webpack_require__.s = moduleId); }
/******/ __webpack_require__.O(0, [1747,4662,7115,8512,9774,2888,179], function() { return __webpack_exec__(26250); });
/******/ var __webpack_exports__ = __webpack_require__.O();
/******/ _N_E = __webpack_exports__;
/******/ }
]);